import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginGuard } from '../security/login.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThemeService } from './services/theme.service';
import { AuthService } from './services/auth.service';
import { ProfileService } from './services/profile.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ShipmentHeaderService } from './services/shipment-header.service';
import { ShipmentNumberComponent } from './shipment-number/shipment-number.component';
import { IconComponent } from './icon/icon.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CountriesService } from './services/countries.service';
import { CardFormComponent } from './card-form/card-form.component';
import { CardSearchService } from './services/card-search.service';
import { TitleService } from './services/title.service';
import { PriceBreakdownComponent } from './price-breakdown/price-breakdown.component';
import { MoneyPipe } from './pipes/money.pipe';
import { QuotingService } from './services/quoting.service';
import { MessagingService } from './services/messaging.service';
import { MaterialModule } from '../material/material.module';
import { ShipmentFilterService } from './services/shipment-filter.service';
import { ShipmentDateFilterService } from './filter/shipment-date-filter.service';
import { ShipmentTextFilterService } from './filter/shipment-text-filter.service';
import { CountryNamePipe } from './pipes/country-name.pipe';
import { ProvinceNamePipe } from './pipes/province-name.pipe';
import { DocumentLinkComponent } from './document-link/document-link.component';
import { DocumentModalComponent } from './document-modal/document-modal.component';
import { DecodeDatePipe } from './pipes/decode-date.pipe';
import { ServerMessageComponent } from './server-message/server-message.component';
import { WeightPipe } from './pipes/weight.pipe';
import { DimensionPipe } from './pipes/dimension.pipe';
import { ShipmentCardFilterService } from './filter/shipment-card-filter.service';
import { CourierFilterService } from './filter/courier-filter.service';
import { ShipmentStatusFilterService } from './filter/shipment-status-filter.service';
import { ShipmentHeaderCardsService } from './column/shipment-header-cards.service';
import { ShipmentHeaderGeneralService } from './column/shipment-header-general.service';
import { AddressBookColumnsService } from './column/address-book-columns.service';
import { ContactColumnsService } from './column/contact-columns.service';
import { ContactAddressBookFilterService } from './filter/contact-address-book-filter.service';
import { ContactCardFilterService } from './filter/contact-card-filter.service';
import { QuickCardFormComponent } from './quick-card-form/quick-card-form.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { SessionExpiredModalComponent } from './session-expired-modal/session-expired-modal.component';
import { InvoiceFilterService } from './filter/invoice-filter.service';
import { InvoiceColumnsService } from './column/invoice-columns.service';
import { PickupColumnsService } from './column/pickup-columns.service';
import { CourierNamePipe } from './pipes/courier-name.pipe';
import { ColumnSelectorComponent } from './column-selector/column-selector.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CreateViewComponent } from './create-view/create-view.component';
import { BatchColumnsService } from './column/batch-columns.service';
import { ShipmentBatchFilterService } from './filter/shipment-batch-filter.service';
import { BatchFilterService } from './filter/batch-filter.service';
import { PackagingTypePipe } from './pipes/packaging-type.pipe';
import { PackageColumnsService } from './column/package-columns.service';
import { CommodityColumnsService } from './column/commodity-columns.service';

@NgModule({ exports: [
        ShipmentNumberComponent,
        IconComponent,
        CardFormComponent,
        PriceBreakdownComponent,
        MoneyPipe,
        CountryNamePipe,
        ProvinceNamePipe,
        DocumentLinkComponent,
        DecodeDatePipe,
        ServerMessageComponent,
        WeightPipe,
        DimensionPipe,
        QuickCardFormComponent,
        CourierNamePipe,
        PackagingTypePipe
    ], imports: [CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        DragDropModule,
        FormsModule,
        ShipmentNumberComponent,
        IconComponent,
        CardFormComponent,
        PriceBreakdownComponent,
        MoneyPipe,
        CountryNamePipe,
        ProvinceNamePipe,
        DocumentLinkComponent,
        DocumentModalComponent,
        DecodeDatePipe,
        ServerMessageComponent,
        WeightPipe,
        DimensionPipe,
        QuickCardFormComponent,
        ConfirmModalComponent,
        SessionExpiredModalComponent,
        CourierNamePipe,
        ColumnSelectorComponent,
        CreateViewComponent,
        PackagingTypePipe], providers: [
        LoginGuard,
        ThemeService,
        AuthService,
        ProfileService,
        ShipmentHeaderService,
        CountriesService,
        CardSearchService,
        TitleService,
        QuotingService,
        MessagingService,
        ShipmentFilterService,
        ShipmentDateFilterService,
        ShipmentTextFilterService,
        ShipmentCardFilterService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SharedModule {
    constructor(private titleService: TitleService,
                private quotingService: QuotingService,
                private shipmentDateFilterService: ShipmentDateFilterService,
                private shipmentTextFilterService: ShipmentTextFilterService,
                private shipmentCardFilterService: ShipmentCardFilterService,
                private shipmentBatchFilterService: ShipmentBatchFilterService,
                private courierFilterService: CourierFilterService,
                private shipmentStatusFilterService: ShipmentStatusFilterService,
                private batchFilterService: BatchFilterService,
                private shipmentHeaderCards: ShipmentHeaderCardsService,
                private shipmentHeaderGeneral: ShipmentHeaderGeneralService,
                private addressBookColumns: AddressBookColumnsService,
                private invoiceColumns: InvoiceColumnsService,
                private pickupColumns: PickupColumnsService,
                private batchColumns: BatchColumnsService,
                private contactColumnsService: ContactColumnsService,
                private packageColumnsService: PackageColumnsService,
                private commodityColumnsService: CommodityColumnsService,
                private contactAddressBookFilterService: ContactAddressBookFilterService,
                private contactCardFilterService: ContactCardFilterService,
                private invoiceFilterService: InvoiceFilterService) {
    }
}
